import { backendColumnMap } from '../hooks/useVehicleSaleReport';

/**
 * Arac Satis Raporu kolon tanimlari.
 * type: 'text' (Contains/Equals vb. metin filtresi) | 'dropdown' (kategorik) | 'date'
 * Basliklar i18n key'leri uzerinden cevrilir (vehicleSaleReport.columns.*).
 */
export const getColumns = (th) => [
    { field: 'dealerName', column: backendColumnMap.dealerName, header: th('vehicleSaleReport.columns.dealerName'), type: 'dropdown', minWidth: '220px' },
    { field: 'chassisNo', column: backendColumnMap.chassisNo, header: th('vehicleSaleReport.columns.chassisNo'), type: 'text', minWidth: '160px' },
    { field: 'modelInfo', column: backendColumnMap.modelInfo, header: th('vehicleSaleReport.columns.modelInfo'), type: 'dropdown', minWidth: '200px' },
    { field: 'customerCity', column: backendColumnMap.customerCity, header: th('vehicleSaleReport.columns.customerCity'), type: 'dropdown', minWidth: '170px' },
    { field: 'customerDetail', column: backendColumnMap.customerDetail, header: th('vehicleSaleReport.columns.customerDetail'), type: 'text', minWidth: '200px' },
    { field: 'customerAddress', column: backendColumnMap.customerAddress, header: th('vehicleSaleReport.columns.customerAddress'), type: 'text', minWidth: '240px' },
    { field: 'saleDate', column: backendColumnMap.saleDate, header: th('vehicleSaleReport.columns.saleDate'), type: 'date', minWidth: '160px' }
];
